export default __webpack_public_path__ + "static/policy4-cddef7e8ee2f78cf473dfff73b6514a8.png";